import { getLogger } from "@core/logging/logger";
import { Service } from "@core/services/service";

export enum ServiceInitPriority {
	Critical = "Critical",
	High = "High",
	Normal = "Normal",
}

type RegisterdService = [Service, string, ServiceInitPriority?];

export class ServicesManager {
	private readonly logger;

	constructor(private readonly services: RegisterdService[]) {
		this.logger = getLogger("🗂️ [ServicesManager]");
	}

	async initServices(): Promise<void> {
		this.logger.debug("----------- Starting app services INIT --------------");

		const byPriority = (priority: ServiceInitPriority) => (service: RegisterdService) =>
			(service[2] ?? ServiceInitPriority.Normal) === priority;

		const criticalServices = this.services.filter(byPriority(ServiceInitPriority.Critical));
		for (const [service, serviceName] of criticalServices) {
			await this.initService(service, serviceName);
		}

		await Promise.all(
			this.services
				.filter(byPriority(ServiceInitPriority.High))
				.map(async ([service, serviceName]) => await this.initService(service, serviceName)),
		);

		await Promise.all(
			this.services
				.filter(byPriority(ServiceInitPriority.Normal))
				.map(async ([service, serviceName]) => await this.initService(service, serviceName)),
		);
		this.logger.debug("----------- App services INIT: DONE --------------");
	}

	private async initService(service: Service, serviceName: string) {
		this.logger.debug(`Initing service ${serviceName}`);
		try {
			await service.init();
			this.logger.debug(`Service ${serviceName} - Inited`);
		} catch (error) {
			this.logger.error(`Could not init service ${serviceName}:`, error);
		}
	}
}
